import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

function UserList(props) {

    const users = props.users;


    const listItems = users.map((user) =>
        <ListItem 
                key={user.id.toString()}
                onClick={ event => props.handleUserChange(event, user.id)}
                sx={{
                    cursor:"pointer",
                    mb:1,
                }}
                className={props.selectedUser === user.id ? "selected" : "list-item"}
        >
            <ListItemText
            primary={user.fname + " " + user.sname}
            secondary={user.email}
            
            />
        </ListItem>
    );

    if(props.loadingState){
        return (
            <></>
        )
    }else{
        return (
            <List sx={{
                mt:2,
                mb: 2,
                maxHeight: 300,
                overflowY: 'scroll',
                paddingRight:'15px'
                }}>
                {listItems}
            </List>
        );
    }
  }
  

  export default UserList;